<template>     
  <v-container>
     <v-card>
        <v-card-text>
          <material-card
          color="green"
          title="Listado de varibles"
          text="Informacion sobre los distintos tipos de variables que maneja la plataforma"
        >
          <v-layout row wrap> 
            <v-flex xs4 pa-1>
              <v-select
                :items="selects" solo v-model="type"
                label="Tipo" item-text="label" item-value="value"
              ></v-select>
            </v-flex>
            <v-flex xs8 pa-1>
              <v-text-field 
                name="search" solo v-model="table.search"
                label="Buscar" append-icon="fa fa-search"
                id="id" />
            </v-flex>
          </v-layout>
           <v-data-table v-model="selected"
              :headers="table.headers"
              :items="table.items"
              :loading="table.loading"
              :search="table.search"
              class="elevation-1"
              item-key="id" show-select 
            >
                <template v-slot:item.actions="props">
                  <td >
                    <v-btn text color="warning" small fab :to="'/admin/variables/edit/' + props.item.id"><v-icon>fa fa-pen</v-icon></v-btn>
                    <v-btn text color="error" small fab @click="confirmDelete(props.item)"><v-icon>fa fa-trash</v-icon></v-btn>
                    <v-btn text color="info" small fab @click="show(props.item)"><v-icon>fas fa-eye</v-icon></v-btn>
                  </td>
                </template>
            </v-data-table> 
        </material-card>
        </v-card-text>
        <v-card-actions>
           <v-btn color="success"  to="/admin/variables/create">Agregar nueva Variable</v-btn> 
        </v-card-actions>
     </v-card>
     <v-dialog
       v-model="modalCreate.active"
       scrollable persistent
       :overlay="false"
       max-width="850px"
       transition="dialog-transition"
     >
      <v-card>
        <v-card-title primary-title>
          <h4 class="display-1">Guardar nueva variable</h4>
          <v-spacer></v-spacer>
          <v-icon text @click="modalCreate.active = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
       
        </v-card-text>
      </v-card>
     </v-dialog>
     <v-dialog
       v-model="modalEdit.active"
       scrollable 
       :overlay="false"
       max-width="500px"
       transition="dialog-transition"
     >
       <v-card>
            <v-card-title primary-title>
              <h4 class="headline">Editar Variables</h4>
            </v-card-title>
            <v-card-text>
               <v-form>
                 
               </v-form>
            </v-card-text>
            <v-card-actions>
               <v-btn color="secondary" @click="modalEdit.active = false">Cancelar</v-btn>
               <v-spacer></v-spacer>
               <v-btn color="primary" @click="update()">Guardar</v-btn>
            </v-card-actions>
         </v-card>
     </v-dialog>
     <v-dialog
       v-model="modalDelete.active"
       scrollable  
       :overlay="false"
       max-width="500px"
       transition="dialog-transition"
     >
         <v-card>
            <v-card-title primary-title>
              <h4 class="headline">Borrar Variables</h4>
            </v-card-title>
            <v-card-text>
               <p>¿ESTA SEGURO DE BORRAR Variables?</p>
            </v-card-text>
            <v-card-actions>
               <v-btn color="secondary" @click="modalDelete.active = false">Cancelar</v-btn>
               <v-spacer></v-spacer>
               <v-btn color="primary" @click="deleteItem()">Borrar</v-btn>
            </v-card-actions>
         </v-card>
     </v-dialog>
     <v-dialog
       v-model="modalShow.active"
       scrollable 
       persistent 
       max-width="900px"
       transition="dialog-transition"
     >
      <v-card>
        <v-card-title primary-title>
          Informacion sobre {{ modalShow.data.name }}
        </v-card-title>
        <v-card-text>
          
        </v-card-text>
        <v-card-actions>
          <v-btn color="info" @click="modalShow.active = false">Salir</v-btn>
        </v-card-actions>
      </v-card>
     </v-dialog>
      <v-snackbar
        :color="alert.color"
        :top="alert.top" 
        :buttom="alert.buttom" 
        :right="alert.right" 
        :left="alert.left"
        v-model="alert.active"
        dark
      >
        <v-icon
          color="white"
          class="mr-3"
        >
          mdi-bell-plus
        </v-icon>
        <div><b>{{ alert.status }}</b>{{ alert.messague }}</div>
        <v-icon
          size="16"
          @click="snackbar = false"
        >
          mdi-close-circle
        </v-icon>
      </v-snackbar>
  </v-container>
</template>
<script>

/* eslint-disable */
  export default{
    created() {

    },
    mounted(){
      this.getData();
      this.activeAlert();
    },
    props: [
      'auth'
    ],
    data(){
      return {
        selected: [],
        apiBasePath: process.env.VUE_APP_URL,
        table: {
          items: [],
          headers: [],
          loading: true,
          search: ''
        },
        modalEdit: {
          active: false,
          data: {
            variable: {
              name: ''
            },
            metadata: {}
          }
        },
        modalCreate: {
          active: false,
          data: {}
        },
        modalDelete: {
          active: false,
          data: {}
        },
        modalShow: {
          active: false,
          data:{}
        },
        alert: {
          color: '',
          messague: '',
          status: '',
          active: false,
          top: false,
          left: false,
          right: false,
          buttom: true,
        },
        allData: [],
        selects: [],
        type: ''
      }
    },
    methods: {
      getData(){
        axios.get(this.apiBasePath + "/api/gis/variables").then((res) => {
          this.table.loading = false;
          if(res.data == "Error"){
            this.alert.active = true;
            this.alert.messague = "Impsoble traer los datos";
            this.alert.status = "500";
            this.alert.color = 'error';
            this.alert.top = false;
            this.alert.buttom = true;
          }else{
            this.table.items = res.data.items;
            this.allData = res.data.items;
            this.table.headers = res.data.headers;
            this.selects = res.data.selects;
            this.selects.push({
              label: 'Todos',
              value: 0
            })
          }
        }).catch((error) => {
          this.table.loading = false;
          this.alert.active = true;
          this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
          this.alert.status = error.response.status
          this.alert.color = 'error';
          this.alert.top = false;
          this.alert.buttom = true;
        });
      },
      create(){
        this.modalCreate.active = true;
        this.modalCreate.data = [];
      },
      
      edit(item){
        this.modalEdit.active = true;
        this.modalEdit.data = item;
      },
      update(){
        axios.put(this.apiBasePath + "/api/gis/variables/edit/" + this.modalEdit.data.id, this.modalEdit.data).then((res) => {
          if(res.data.success != "Exito"){
            this.alert.active = true;
            this.alert.messague = "Los datos suministrados estan incompletos o no son validos";
            this.alert.status = "500";
            this.alert.color = 'error';
            this.alert.top = false;
            this.alert.buttom = true;
          }else{
            this.alert.active = true;
            this.alert.messague = "Actualizado correctamente";
            this.alert.status = "200";          
            this.alert.color = 'success'
            this.alert.top = false;
            this.alert.buttom = true;
            this.getData();

          }
        }).catch((error) => {
          this.alert.active = true;
          this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
          this.alert.status = error.response.status
          this.alert.color = 'error';
        });
      },
      confirmDelete(item){
        this.modalDelete.active = true;
        this.modalDelete.data = item;
      },
      store(alert){
        this.alert = alert;
        if(alert.color == success){
          this.modalCreate.active = false;
          this.getData();
        }
      },
      deleteItem(){
        axios.delete(this.apiBasePath + "/api/gis/variables/destroy/" + this.modalDelete.data.id, this.modalDelete.data).then((res) => {
          if(res.data != "exito"){
            this.alert.active = true;
            this.alert.messague = "Imposible de eliminar";
            this.alert.status = "500";
            this.alert.color = 'error'
          }else{
            this.alert.active = true;
            this.alert.messague = "Eliminado correctamente";
            this.alert.status = "200";
            this.alert.color = 'success'
            this.modalDelete.active = false
            this.getData();
          }  
        }).catch((error) => {
          this.alert.active = true;
          this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
          this.alert.status = error.response.status
          this.alert.color = 'error';
        });
      },
      activeAlert(){
        
        if(this.$route.query.status == 1){
          this.alert.active = true;
          this.alert.messague = "Variable Guardada Exitosamente";
          this.alert.status = ''
          this.alert.color = 'success';
          this.alert.top = true;
          this.alert.buttom = false;
        }else if(this.$route.query.status == 2){
          this.alert.active = true;
          this.alert.messague = "Variable editada correctamente";
          this.alert.status = ''
          this.alert.color = 'success';
          this.alert.top = true;
          this.alert.buttom = false;
        }
      },
      show(item){
        this.modalShow.active = true; 
        this.modalShow.data = item; 
      }
    },
    watch: {
      type: function (){
        if(this.type != 0){
          var types = this.type
          this.table.items = this.allData.filter(function(item){
            return item.id_type == types
          })
        }else{
          this.table.items = this.allData;
        }
      }
    },
    computed: {

    },
  }
/* eslint-enable */
</script>